import { create } from 'zustand';
import type { ConsentData, PersonalInfo } from '../types';

export type VerificationStep =
  | 'consent'
  | 'personal-info'
  | 'otp-verification'
  | 'id-upload'
  | 'selfie'
  | 'review'
  | 'payment';

interface VerificationState {
  requestId: string | null;
  currentStep: VerificationStep;
  consent: ConsentData | null;
  personalInfo: PersonalInfo | null;
  phoneVerified: boolean;
  idDocumentId: string | null;
  selfieDocumentId: string | null;
  geolocationCaptured: boolean;

  setRequestId: (id: string) => void;
  setStep: (step: VerificationStep) => void;
  setConsent: (consent: ConsentData) => void;
  setPersonalInfo: (info: PersonalInfo) => void;
  setPhoneVerified: (verified: boolean) => void;
  setIdDocumentId: (id: string) => void;
  setSelfieDocumentId: (id: string) => void;
  setGeolocationCaptured: (captured: boolean) => void;
  reset: () => void;
}

const initialState = {
  requestId: null,
  currentStep: 'consent' as VerificationStep,
  consent: null,
  personalInfo: null,
  phoneVerified: false,
  idDocumentId: null,
  selfieDocumentId: null,
  geolocationCaptured: false,
};

export const useVerificationStore = create<VerificationState>((set) => ({
  ...initialState,

  setRequestId: (id) => set({ requestId: id }),
  setStep: (step) => set({ currentStep: step }),
  setConsent: (consent) => set({ consent }),
  setPersonalInfo: (info) => set({ personalInfo: info }),
  setPhoneVerified: (verified) => set({ phoneVerified: verified }),
  setIdDocumentId: (id) => set({ idDocumentId: id }),
  setSelfieDocumentId: (id) => set({ selfieDocumentId: id }),
  setGeolocationCaptured: (captured) => set({ geolocationCaptured: captured }),
  reset: () => set(initialState),
}));
